import React from 'react';
import {
  IProductAllocations,
  ProductAllocationProducts,
} from 'modules/2023-q3/allocation/interface/product-allocation';
import { Box, Divider } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { useHideProduct } from 'modules/2023-q4/white-label/hooks/use-hide-product';
import { PortfolioAllocationListItem } from './components/portfolio-allocation-list-item/portfolio-allocation-list-item';

interface Props {
  allocation: IProductAllocations;
  title?: string;
  totalAmount: number;
}

export const PortfolioAllocationList: React.FC<Props> = ({
  allocation,
  title,
  totalAmount,
}) => {
  const { hideProduct } = useHideProduct();

  return (
    <>
      {title && (
        <Box mb={2}>
          <Typography color="black19" variant={TypographyVariant.Header5}>
            {title}
          </Typography>
        </Box>
      )}

      {Object.entries(allocation).map((productAllocation) => {
        const allocationValue =
          totalAmount * (productAllocation[1].value / 100);

        if (hideProduct(productAllocation[0])) {
          return null;
        }

        return (
          <Box my={2} key={productAllocation[0]}>
            <Box mb={2}>
              <Divider />
            </Box>

            <PortfolioAllocationListItem
              allocationPercentage={productAllocation[1].value}
              allocationValue={allocationValue}
              productName={productAllocation[0]}
            />
          </Box>
        );
      })}
    </>
  );
};
